import { render } from "./me-page.vue?vue&type=template&id=bcef3698"
import script from "./me-page.vue?vue&type=script&lang=js"
export * from "./me-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__